import {
  browserSupportsWebAuthn,
  browserSupportsWebAuthnAutofill,
  startAuthentication,
  startRegistration,
} from "@simplewebauthn/browser";

import { useFetch, useMutate } from "@/lib/hooks/use-fetch";
import kohost from "lib/api/client";

import {
  DescribeMyPasskeyRegistrationsCommand,
  FinishRegisterPasskeyCommand,
  StartRegisterPasskeyCommand,
} from "@kohost/api-client/useCases";

const startPasskeyRegistration = async () => {
  const cmd = new StartRegisterPasskeyCommand({});
  const response = await kohost.send(cmd);
  const registrationData = response.data[0];
  return registrationData;
};

const getSavedRegistations = async () => {
  const cmd = new DescribeMyPasskeyRegistrationsCommand({});
  const response = await kohost.send(cmd);
  const registrations = response.data;
  return registrations;
};

export const usePasskey = () => {
  const authenticateMutation = useMutate({
    mutationFn: (options) => {
      return startAuthentication(options);
    },
  });

  const registerMutation = useMutate({
    mutationFn: async () => {
      const { challengeId, options } = await startPasskeyRegistration();
      const challengeResponse = await startRegistration(options);

      const cmd = new FinishRegisterPasskeyCommand({
        data: { challengeId, challengeResponse },
      });

      return await kohost.send(cmd);
    },
    refetchOnWindowFocus: false,
    retry: false,
  });

  const getSavedRegistrationsQuery = useFetch({
    queryKey: ["passkeys"],
    queryFn: getSavedRegistations,
    retry: false,
  });

  return {
    register: registerMutation,
    authenticate: authenticateMutation,
    getSavedRegistations: getSavedRegistrationsQuery,
    browserSupportsWebAuthn,
    browserSupportsWebAuthnAutofill,
  };
};
